import React from 'react';
import Skeleton from 'react-loading-skeleton';

const SkeletonCard = ({ rows = 7, title = true, circle = false }) => {
  return (
    <section>
      <article className="card skeleton">
        <section className="card__header">
          {title && (
            <h6 className="card__title">
              <Skeleton width={`30%`} />
            </h6>
          )}
          {circle && (
            <div className="u--text-align-center">
              <Skeleton circle={true} height={100} width={100} />
            </div>
          )}
        </section>
        <section className="card__body">
          <Skeleton
            height={40}
            width={`100%`}
            count={rows}
            style={{ marginBottom: 15 }}
          />
        </section>
      </article>
    </section>
  );
};

export default SkeletonCard;
